import {getPropertyList} from "@model/Property";


let mView:any;
export function initView(db){
    mView = db.table('view');
}

export async function getViewById(id){
    return mView.get(id);
}

export function getAllViewList(){
    return mView.toArray();
}

export async function getViewList(tagName:any){
    const arrayViews = await mView.where('tagName').equals(tagName).toArray();
    //所有属性...
    const arrayProgertys = await getPropertyList();
    for (let i=0;i<arrayViews.length;i++){

        const arrayDeleteIds:any = [];
        for (let j=0;j<arrayViews[i].columns.length;j++){
            const column = arrayViews[i].columns[j];
            const dbColumn = arrayProgertys.find(p=>p.id == column.id);
            if (dbColumn){
                column.name = dbColumn.name;
            }else{
                if (column.id.length > 30){
                    arrayDeleteIds.push(column.id);
                }
            }
        }

        //移除视图中不存在的列..
        for (let j=0;j<arrayDeleteIds.length;j++){
            //删除
            const nIndex = arrayViews[i].columns.findIndex(p=>p.id == arrayDeleteIds[j]);
            if (nIndex != -1){
                arrayViews[i].columns.splice(nIndex,1);
            }
        }
    }

    return arrayViews;
}

export async function getViewListByTagNames(arrayTags){
    if (arrayTags){
        return mView.where('tagName').anyOf(arrayTags).toArray();
    }
    return null;
}

export function updateView(view){
    if (!view.createTime){
        view.createTime = Date.now();
    }
    delete view.data;

    return mView.put(view);
}

export function batchUpdateViews(arrayViews){
    arrayViews.forEach(view=>{
        if (!view.createTime){
            view.createTime = Date.now();
        }
        delete view.data;
    })
    return mView.bulkPut(arrayViews);
}

export async function updateViewTagName(szOldTagName,szNewTagName){
    const arrayViews = await getViewList(szOldTagName);
    for (let i=0;i<arrayViews.length;i++){
        arrayViews[i].tagName = szNewTagName;
    }
    return mView.bulkPut(arrayViews);
}

export function deleteView(id){
    return mView.delete(id);
}

export function deleteViews(arrayIds){
    return mView.bulkDelete(arrayIds);
}

/**
 *
 * @param szColumnId
 */
export function staticTagsInColumn(szColumnId:any){
    return new Promise(resolve => {
        let szTags:any = '';
        mView.toArray().then(arrayList=>{
            for (let i=0;i<arrayList.length;i++){
                const arrayColumns = arrayList[i].columns;
                if (arrayColumns){
                    if (arrayColumns.some(p=>p.id == szColumnId)){
                        if (!szTags.includes(arrayList[i].tagName)){
                            szTags += arrayList[i].tagName + ',';
                        }
                    }
                }
            }
            if (szTags.length > 0){
                szTags = szTags.substring(0,szTags.length-1);
            }
            resolve(szTags);
        })
    })
}


























